import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Chip as MuiChip, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { withDefaultPropsAndStyles } from '../utils';
export { MuiChip as BaseChip };
/*
these are custom colors
*/
const useStyles = makeStyles(({ palette }) => ({
    colorSuccess: {
        backgroundColor: palette.success.main,
        color: palette.common.white,
    },
    colorWarning: {
        backgroundColor: palette.warning.main,
        color: palette.common.white,
    },
    colorError: {
        backgroundColor: palette.error.main,
        color: palette.common.white,
    },
}));
const StyledChip = withDefaultPropsAndStyles('Chip', MuiChip, {
    styles: () => ({
        // NOTE: these empty styles need to exist here in order for the
        // theme-specific overrides to be applied.
        root: {},
        deleteIcon: {},
        outlined: {},
        outlinedPrimary: {},
        outlinedSecondary: {},
    }),
});
export const Chip = (props) => {
    const { color, className } = props, forwardedProps = __rest(props, ["color", "className"]);
    const classes = useStyles();
    let colorClassName = '';
    let forwardedColor = color;
    /*
    Not supported properly , will add them when moved to MUI v5
    */
    switch (color) {
        case 'success':
            forwardedColor = 'primary';
            colorClassName = classes.colorSuccess;
            break;
        case 'warning':
            forwardedColor = 'default';
            colorClassName = classes.colorWarning;
            break;
        case 'error':
            forwardedColor = 'default';
            colorClassName = classes.colorError;
            break;
        default:
            break;
    }
    /**
     * Forces non-MUI color variants to act as a MUI color variant
     */
    forwardedColor = forwardedColor;
    return _jsx(StyledChip, Object.assign({}, forwardedProps, { color: forwardedColor, className: clsx(className, colorClassName) }), void 0);
};
//# sourceMappingURL=Chip.js.map